/* tslint:disable */
/* eslint-disable */
export enum WorkOrderStatus {
  Invoiced = 'INVOICED',
  Credited = 'CREDITED',
  Debited = 'DEBITED',
  Processing = 'PROCESSING',
}
